"use client";

import { useTranslations } from "next-intl";
import { Control, FieldErrors } from "react-hook-form";

import { FinanceFormData } from "../schema";
import FormRadio from "@/components/common/forms/FormRadioGroup";

interface QuestionStep2Props {
  control: Control<FinanceFormData>;
  errors: FieldErrors<FinanceFormData>;
  NextStep: () => void;
  PrevStep: () => void;
  stepIndex: number;
}

const QuestionStep2: React.FC<QuestionStep2Props> = ({ control }) => {
  const t = useTranslations("Finance.form.step2");

  const salaryOptions = [
    { value: "wps", label: t("question1.options.yes") },
    { value: "other", label: t("question1.options.no"), isNegative: true },
  ];

  const isCompanyOldOptions = [
    { value: "yes", label: t("question2.options.yes") },
    { value: "no", label: t("question2.options.no"), isNegative: true },
  ];

  return (
    <div className="mt-10">
      <div className="space-y-8">
        <div>
          <h4 className="inter mb-4 text-base font-semibold text-gray-900">{t("question1.title")}</h4>
          <FormRadio<FinanceFormData> name="salaryType" control={control} label="" options={salaryOptions} />
        </div>
        <div>
          <h4 className="inter mb-4 text-base font-semibold text-gray-900">{t("question2.title")}</h4>
          <FormRadio<FinanceFormData>
            name="isCompanyOlderThanOneYear"
            control={control}
            label=""
            options={isCompanyOldOptions}
          />
        </div>
      </div>
    </div>
  );
};

export default QuestionStep2;
